import React from "react";

// Red Flags / Must Capture headline (server `*_consistency`): per rubric item, captured in EVERY repeat of the
// same case x persona / in some / in none — averaged over cases, + 95% CI over cases. Line 1 = the headline,
// a thin bar = the split (one neutral ramp; red only for "never"), line 2 = the split in words. No repeats ->
// the single-run rate; a pre-split experiment (no item lists) falls back to the old mean ± SD.
const pct = (x) => Math.round(x * 100) + "%";
const BAR = { every_time: "#511ccd", sometimes: "#c9bdf0", never: "var(--bad)" };
export default function ConsistencyCell({ c, legacyText }) {
  if (!c || !c.n_cases) return <span>{legacyText}</span>;
  const ci = c.ci ? <span className="muted"> ({pct(c.ci[0])}–{pct(c.ci[1])})</span> : null;
  if (!c.repeats) {
    return (
      <>
        <div>{pct(c.single_run)}{ci}</div>
        <div className="muted" style={{ fontSize: 11 }}>single run per case (no repeats)</div>
      </>
    );
  }
  return (
    <>
      <div style={{ whiteSpace: "nowrap" }}><strong>{pct(c.every_time)}</strong> every time{ci}</div>
      <div className="cbar" aria-hidden="true">
        {["every_time", "sometimes", "never"].map((k) => (c[k] > 0
          ? <span key={k} style={{ width: `${c[k] * 100}%`, background: BAR[k] }} /> : null))}
      </div>
      <div className="muted" style={{ fontSize: 11, whiteSpace: "nowrap" }}>
        {pct(c.sometimes)} sometimes · <span style={c.never > 0 ? { color: "var(--bad)", fontWeight: 700 } : undefined}>{pct(c.never)} never</span>
      </div>
    </>
  );
}
// The value a consistency headline ranks by: "every time", else the single-run rate.
export const consistencyRank = (c) => (!c || !c.n_cases ? null : c.repeats ? c.every_time : c.single_run);
